"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8914],{

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 50410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroDescription = (param)=>{
    let { align , color ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__description", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroDescription.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .textAlignPropTypes */ .g4,
    color: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroDescription);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 69591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Hero.js









const Hero = (param)=>{
    let { align ="center" , children , color ="black--02" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , backgroundImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("section-hero", align && "section-hero-text-".concat(align), color && "section-hero-color-".concat(color), "".concat(backgroundImage ? "section-hero-custom-background" : ""), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        style: {
            ...backgroundImage && {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
Hero.propTypes = {
    align: props_sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired,
    color: (0,prop_types.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "transparent",
        "gradient"
    ]),
    backgroundImage: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const SimpleTemplateForm = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            md: 8,
            children: children
        })
    });
};
SimpleTemplateForm.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateForm);


/***/ }),

/***/ 70504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);







const SimpleTemplateTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , size ="xl" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            fontSize: size,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            mb: 6
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
SimpleTemplateTitle.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateTitle);


/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 41848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const TableResponsiveWrapper = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table-responsive", className),
        children: children
    });
};
TableResponsiveWrapper.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (TableResponsiveWrapper);


/***/ }),

/***/ 72483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Tbody = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
        ...props,
        children: children
    });
};
Tbody.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Tbody);


/***/ }),

/***/ 182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18981);








const Td = (param)=>{
    let { className ="" , align , isBorderNone =false , isActive =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , verticalAlign , children , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__td", isActive && "table-active", align && "table__td--".concat(align), verticalAlign && "table__td-vertical-align--".concat(verticalAlign), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Td.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    align: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .textAlignPropTypes */ .g4,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_7__.node,
    verticalAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "baseline",
        "top",
        "middle",
        "sub",
        "bottom",
        "text-top"
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Td);


/***/ }),

/***/ 11794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18981);








const Th = (param)=>{
    let { className ="" , isBorderNone =false , isActive =false , children , align ="" , verticalAlign , isUppercaseNone =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__th", isActive && "table-active", align && "table__th--".concat(align), verticalAlign && "table__th-vertical-align--".concat(verticalAlign), isUppercaseNone && "table__th--uppercase-none", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Th.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_7__.node,
    isUppercaseNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    align: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "left",
        "right",
        "center"
    ]),
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingPropTypes */ .Xj,
    verticalAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "baseline",
        "top",
        "middle",
        "sub",
        "bottom",
        "text-top"
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Th);


/***/ }),

/***/ 40662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const Thead = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
        ...props,
        children: children
    });
};
Thead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Thead);


/***/ }),

/***/ 455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18981);







const Tr = (param)=>{
    let { className ="" , isBorderNone =false , isActive =false , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    } , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__tr", isActive && "table-active", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Tr.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityPropTypes */ .pQ,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingPropTypes */ .Xj
};
/* harmony default export */ __webpack_exports__["Z"] = (Tr);


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Table_Table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Table.js





const Table = (param)=>{
    let { className ="" , isStriped =false , isBottomBorderedStriped =false , isBottomBordered =false , isBordered =false , isBorderedWrapper =false , children , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
        className: (0,classes/* classes */.S)("table", isBottomBordered && "table-bottom-bordered", isBottomBorderedStriped && "table-bottom-bordered-striped", isBordered && "table-bordered", isBorderedWrapper && "table-bordered-wrapper", isStriped && "table-striped", ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Table.propTypes = {
    className: prop_types.string,
    isBottomBordered: prop_types.bool,
    isBordered: prop_types.bool,
    isBorderedWrapper: prop_types.bool,
    isStriped: prop_types.bool,
    isBottomBorderedStriped: prop_types.bool,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Table_Table = (Table);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js



/***/ }),

/***/ 23402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ ViewerPageTemplateSimpleTemplate; },
/* harmony export */   "AQ": function() { return /* binding */ ViewerPageTemplateSection; },
/* harmony export */   "F_": function() { return /* binding */ ViewerPageTemplateTableSectionSubTitle; },
/* harmony export */   "GI": function() { return /* binding */ ViewerPageTemplateTableSectionText; },
/* harmony export */   "Mv": function() { return /* binding */ ViewerPageTemplateTablesSection; },
/* harmony export */   "QA": function() { return /* binding */ ViewerPageTemplateSectionSubTitle; },
/* harmony export */   "QB": function() { return /* binding */ ViewerPageTemplateDownloadRow; },
/* harmony export */   "Wc": function() { return /* binding */ ViewerPageTemplateSectionTitle; },
/* harmony export */   "_b": function() { return /* binding */ ViewerPageTemplateTableSectionTitle; },
/* harmony export */   "cI": function() { return /* binding */ ViewerPageTemplateTableWrapper; },
/* harmony export */   "cb": function() { return /* binding */ ViewerPageTemplateDownloadWrapper; },
/* harmony export */   "gd": function() { return /* binding */ ViewerPageTemplateDownloadItem; },
/* harmony export */   "gr": function() { return /* binding */ ViewerPageTemplateDownloadItemLink; },
/* harmony export */   "nJ": function() { return /* binding */ ViewerPageTemplateSimpleTemplateText; },
/* harmony export */   "xx": function() { return /* binding */ ViewerPageTemplateHeading; }
/* harmony export */ });
/* unused harmony export ViewerPageTemplateTable */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61672);
/* harmony import */ var _SimpleTemplate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35449);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72379);
/* harmony import */ var _Table_Tbody__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72483);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67924);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74229);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67478);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93512);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2349);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7820);
















const ViewerPageTemplateSection = (param)=>{
    let { children , className , sm , md , lg  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
                mx: true,
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                    sm: sm,
                    md: md,
                    lg: lg,
                    className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)(className),
                    children: children
                })
            })
        })
    });
};
ViewerPageTemplateSection.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_14__.string,
    sm: prop_types__WEBPACK_IMPORTED_MODULE_14__.number,
    md: prop_types__WEBPACK_IMPORTED_MODULE_14__.number,
    lg: prop_types__WEBPACK_IMPORTED_MODULE_14__.number
};
const ViewerPageTemplateSectionTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxProps */ .ET
    } , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            fontSize: "xl",
            fontWeight: "normal",
            textAlign: "center",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(sx)
        },
        ...props,
        children: children
    });
};
ViewerPageTemplateSectionTitle.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxPropTypes */ .I1,
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateSectionSubTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxProps */ .ET
    } , children , className =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)(className),
        sx: {
            fontSize: "m",
            fontWeight: "normal",
            textAlign: "center",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(sx)
        },
        children: children
    });
};
ViewerPageTemplateSectionSubTitle.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxPropTypes */ .I1,
    className: prop_types__WEBPACK_IMPORTED_MODULE_14__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTablesSection = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        spacing: {
            mb: 20
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
                mx: true,
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                    md: 12,
                    lg: 12,
                    children: children
                })
            })
        })
    });
};
ViewerPageTemplateTablesSection.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTableSectionTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            fontWeight: "bold",
            textAlign: "center"
        },
        children: children
    });
};
ViewerPageTemplateTableSectionTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTableSectionSubTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            fontWeight: "normal",
            textAlign: "center"
        },
        children: children
    });
};
ViewerPageTemplateTableSectionSubTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTableSectionText = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            fontWeight: "normal"
        },
        spacing: {
            px: 2,
            m: 0
        },
        children: children
    });
};
ViewerPageTemplateTableSectionText.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTableWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
        mx: true,
        px: true,
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
            sm: 12,
            md: 12,
            lg: 12,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
                mx: true,
                px: true,
                utility: {
                    justify: "center"
                },
                children: children
            })
        })
    });
};
ViewerPageTemplateTableWrapper.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateTable = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        isBottomBorderedStriped: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Table_Tbody__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: children
        })
    });
};
ViewerPageTemplateTable.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateSimpleTemplate = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleTemplate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        utility: {
            bgColor: "white"
        },
        panelPaddingY: 8,
        ...props,
        children: children
    });
};
ViewerPageTemplateSimpleTemplate.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateSimpleTemplateText = (param)=>{
    let { size ="xxxl" , weight ="normal" , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_13__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            fontSize: size,
            fontWeight: weight,
            textAlign: "center",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            mb: 4,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(spacing)
        },
        ...props
    });
};
ViewerPageTemplateSimpleTemplateText.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_13__/* .spacingPropTypes */ .Xj,
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"].propTypes */ .Z.propTypes
};
const ViewerPageTemplateHeading = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxProps */ .ET
    } , size ="xl" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h2",
        sx: {
            fontSize: size,
            textAlign: "center",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            mt: 14
        },
        ...props
    });
};
ViewerPageTemplateHeading.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_12__/* .sxPropTypes */ .I1,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const ViewerPageTemplateDownloadWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
            md: 11,
            lg: 10,
            children: children
        })
    });
};
ViewerPageTemplateDownloadWrapper.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateDownloadRow = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
        mx: true,
        children: children
    });
};
ViewerPageTemplateDownloadRow.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateDownloadItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
        md: 6,
        spacing: {
            mb: 6
        },
        children: children
    });
};
ViewerPageTemplateDownloadItem.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired
};
const ViewerPageTemplateDownloadItemLink = (param)=>{
    let { children , href , icon , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link */ .Z.Link, {
        href: href,
        size: "s",
        isBlock: true,
        className: "px-0",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                name: icon
            }),
            " ",
            children
        ]
    });
};
ViewerPageTemplateDownloadItemLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_14__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired,
    icon: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
};


/***/ }),

/***/ 37894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const fallback = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const theHandler = (err)=>handler(err, ...args);
            try {
                const result = fn(...args);
                return (0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.catch(theHandler) : result;
            } catch (err) {
                return theHandler(err);
            }
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (fallback);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ })

}]);